<template>
    <div>
        <el-table :data="dataList"
                  style="width: 100%"
                  row-class-name="data-row-class">
            <el-table-column prop="id"
                             width="160px"
                             label="ID" />
            <el-table-column
                width="80px"
                label="类型"
            >
                <template slot-scope="scope">
                    {{ getProductType(scope.row.type) }}
                </template>
            </el-table-column>
            <el-table-column prop="type"
                             width="80px"
                             label="发布状态">
                <template slot-scope="scope">{{ getValue(scope.row.published) }}</template>
            </el-table-column>
            <el-table-column label="保险公司">
                <template slot-scope="scope">{{ getCompanyName(scope.row.basicInfo.companyId) }}</template>
            </el-table-column>
            <el-table-column prop="basicInfo.name"
                             label="产品名称" />
            <el-table-column prop="basicInfo.contractName"
                             label="产品合同名" />
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="small"
                               @click="view(scope.$index)">查看</el-button>
                    <el-button size="small" 
                                @click="edit(scope.$index)">编辑
                                </el-button>
                    <!--                <el-button size="small"
                                               @click="remove(scope.$index)">删除</el-button>-->

                </template>
            </el-table-column>
        </el-table>
<!--        <Pager
            :currentPageCount="dataList.length"
            @page-changed="onDataChanged"
            :defaultPageSize="100"
        ></Pager>-->
        <pager
            ref="pager"
            api="list"
            model="library"
            :defaultPageSize="10"
            @data-changed="onDataChanged"
            class="pager"
        />
        <el-dialog title="产品详情"
                   :visible.sync="showDetail"
                   width="70%">
            <ListDialog :type="viewType"
                            :key="viewIndex"
                            :data="viewData"
                            check-required
                            publish
                            disabled></ListDialog>
            <el-button type="primary" size="small" @click="showDetail = !showDetail">确定</el-button>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/api/request.js"
import ListDialog from './ListDialog'
import Pager from "@/modules/ui/Pager.vue"
export default {
    components: {
        ListDialog,
        Pager
    },
    computed: {
        viewType() { return this.m[(this.dataList[this.viewIndex] || {}).type] },
        viewData() { return (this.dataList[this.viewIndex] || {}) }
    },
    data(){
        return {
            data: null,
            dataList: [],
            typeStr: {
                0:"医疗险",
                1:"重疾险",
                2:"寿险",
                3:"意外险"
            },
            m: {
                0: 'medical',
                1: 'critical_illness',
                2: 'term_life',
                3: 'accident',
                4: 'annual'// "年金险"
            },
            showDetail: false,
            viewIndex: 0,
            currentRange: [0, 10],
            companyOptions: [],
            productTypeList: []
        }
    },
    created() {
        //this.loadData([0, 100]);
        this.initData()
        this.getCompanyOptions()
        this.$store.commit('addProductInfo', {})
    },
    methods: {
        initData(){
            //获取产品类型信息
            request.saas
                .post("product/product_type_list", {})
                .then(resp => {
                    this.productTypeList = resp.data.list
                })
        },
        onDataChanged: function (data) {
            this.dataList = data
        },
        getCompanyOptions(){
            request.product
                .post(
                    'company_list',
                    {
                        range: [0,1000]
                    }
                )
                .then(res => {
                    this.companyOptions = res.data.list
                })  
        },
        getCompanyName(id){
            let name
            this.companyOptions.forEach(i => {
                
                if(i.id === id){
                    name = i.name
                }
            }) 
            return name
        },
        view(index) {
            this.showDetail = true
            this.viewIndex = index
        },
        edit(index) {
            this.viewIndex = index
            this.$store.commit('addProductInfo', this.viewData)
            this.$router.push({
                path: '/product_library/edit'
            })
            
        },
        getValue(t){
            return t ? '是' : '否'
        },
        getProductType(type){
            //获取产品类型
            for (const opt of this.productTypeList) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
    }
}
</script>
